import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { travelVoucherFormDefault } from "@factory/form/form.default";
import { TravelVoucherFormRule, TravelVoucherFormSchema } from "@factory/form/form.rule";
import { useQyCreateTravelVoucher } from "@factory/query/travel-voucher.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewTravelVoucher() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTravelVoucher } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New TravelVoucher is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTravelVoucher, isLoading: isCreating } =
    useQyCreateTravelVoucher(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TravelVoucherFormSchema>({
    defaultValues: travelVoucherFormDefault,
    resolver: zodResolver(TravelVoucherFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TravelVoucherFormSchema) => {
    const formData = mapCreateTravelVoucher(form);
    addTravelVoucher(formData);
  };
  const handleValidateError = (err: FieldErrors<TravelVoucherFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
